<div class="viewer-host">
  <div #viewer class="viewer-mount"></div>

  @if (isLoading()) {
    <div class="viewer-overlay">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (hasLoadError()) {
    <div class="viewer-overlay">
      <p class="body-300 color-gray-400 ta--center">
        We couldn't load this document. Please try again later.
      </p>
    </div>
  }
</div>
